import { createFileRoute } from "@tanstack/react-router";
import AdminBlog from "@/pages/admin/AdminBlog";

export const Route = createFileRoute("/_adminLayout/admin/blog")({
  component: AdminBlog,
});
